import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  height: 48px;
  padding-left: 24px;
  display: flex;
  align-items: center;

  &.no-title {
    height: 24px;
    .close {
      transform: translate(-8px, 6px);
    }
  }

  &:not(.no-title)::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: #e8eaf2;
  }

  .title {
    flex: 1;
    font-weight: 600;
    font-size: 14px;
    color: #424770;
  }
  .close {
    width: 24px;
    height: 24px;
    transform: translate(-8px, -6px);
    border-radius: 50%;
    &:hover {
      cursor: pointer;
      background-color: #e3f5de;
    }
  }
`

const ModalHeader: React.FC<{ title?: React.ReactNode; onClose: () => void }> = ({ title, onClose }) => {
  return (
    <Wrapper className={`ModalHeader ${!title && 'no-title'}`}>
      <div className="title">{title}</div>
      <div className="close" onClick={onClose}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L10.5858 12L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L12 13.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L13.4142 12L16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L12 10.5858L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289Z"
            fill="#99A4AE"
          />
        </svg>
      </div>
    </Wrapper>
  )
}

export default ModalHeader
